import { Privacy } from '@/models/enums';
import { useCallback, useState } from 'react';
import { flushSync } from 'react-dom';
import { axiosGetPrivacyPolicyStatus, getPrivacyUserConsent } from '../stateManagement/api';

const usePrivacyPolicyStatus = () => {
  const [status, setStatus] = useState<Privacy.PrivacyPolicyStatus>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onUpdateFailure = (err?: Error) => {
    setError(true);
  };

  // Remove useCallback
  const fetchData = useCallback(async (token: string) => {
    try {
      const response = await getPrivacyUserConsent(token);
      if (response?.status === 200) {
        const acknowledgementStatus = response?.data?.acknowledgementStatus;
        flushSync(() => {
          setStatus(acknowledgementStatus);
        });
        setLoading(false);
      } else {
        setError(true);
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getPrivacyPolicyStatus: fetchData,
    onFailure: onUpdateFailure,
    status,
    loading,
    error,
  };
};

export default usePrivacyPolicyStatus;
